const MAX = 8

function storageKey(key) {
    return `search:${key}`
}

export function useRecentSearches() {
    function getRecent(key) {
        try {
            return JSON.parse(sessionStorage.getItem(storageKey(key)) ?? '[]')
        } catch {
            return []
        }
    }

    function addRecent(key, term) {
        const t = term?.trim()
        if (!t) return
        const existing = getRecent(key).filter(e => e !== t)
        const updated = [t, ...existing].slice(0, MAX)
        try {
            sessionStorage.setItem(storageKey(key), JSON.stringify(updated))
        } catch { }
    }

    function clearAll(key) {
        try {
            sessionStorage.removeItem(storageKey(key))
        } catch { }
    }

    return { getRecent, addRecent, clearAll }
}
